module.exports = __webpack_public_path__ + "static/media/safari.40e0fdd3.png";